module.exports = __webpack_public_path__ + "assets/img/d875-mr.svg";